<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div>
    <div class="">
      <div class="flex flex-col h-screen justify-center">
        <main class="mb-auto bg-black">
          <router-view />
        </main>
        <footer-a> </footer-a>
      </div>
    </div>
  </div>
</template>
<script>
import footerA from "./footer.vue";

export default {
  mounted() {
    this.title = this.$route.meta.prtitle;
    var token = localStorage.getItem("token");
    if (token == null) {
      this.$router.push({ name: "Register" });
    }
  },
  data() {
    return {
      title: null,
      showMenu: false,
      message: false,
    };
  },
  methods: {
    showMenuHandler() {
      this.showMenu = !this.showMenu;
    },
  },
  components: {
    footerA,
  },
};
</script>
